export enum ProductTypes {
  GOODS = 'goods',
  SERVICES = 'services',
  DIGITAL = 'digital_products',
  BUNDLE = 'bundle',
  ARBITRARY = 'arbitrary',
  CORRECTION = 'correction',
  OVERDUE_FEE = 'overdue_fee',
  GENERAL = 'general',
  UNASSIGNED = 'unassigned',
  PREPAYMENT = 'prepayment',
  INVOICE = 'invoice',
  CREDIT_NOTE = 'credit_note',
  CREDIT = 'credit',
  // MEDIA = 'media',
}

export enum ProductEntityTypes {
  GENERAL = 'general_product',
  PRODUCT = 'product',
  UNIT = 'product_unit',
}
